import { useNavigate } from "react-router-dom";
import { Star, Clock, BarChart3 } from "lucide-react";
import { formatPrice } from "@/lib/api";

const CAT_COLOR = {
  "Inteligencia Artificial": "text-[#00E5FF] border-[#00E5FF]/30 bg-[#00E5FF]/10",
  "Informática": "text-[#7000FF] border-[#7000FF]/30 bg-[#7000FF]/10",
  "Ingeniería de Sistemas": "text-[#00E6BA] border-[#00E6BA]/30 bg-[#00E6BA]/10",
  "Ingeniería Civil": "text-[#FFB020] border-[#FFB020]/30 bg-[#FFB020]/10",
  "Contabilidad": "text-[#A3E635] border-[#A3E635]/30 bg-[#A3E635]/10",
  "Administración": "text-[#FB7185] border-[#FB7185]/30 bg-[#FB7185]/10",
};

export default function CourseCard({ course }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid={`course-card-${course.slug}`}
      onClick={() => navigate(`/curso/${course.slug}`)}
      className="group cursor-pointer bg-[#0C0D12] border border-white/5 rounded-lg overflow-hidden hover:border-[#00E5FF]/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(0,229,255,0.1)]"
    >
      <div className="relative h-44 overflow-hidden">
        <img src={course.image_url} alt={course.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0C0D12] via-[#0C0D12]/30 to-transparent" />
        <span className={`absolute top-3 left-3 font-mono text-[10px] uppercase tracking-wider px-2 py-1 rounded border ${CAT_COLOR[course.category] || "text-white border-white/20 bg-white/5"}`}>
          {course.category}
        </span>
      </div>
      <div className="p-6">
        <h3 className="font-heading font-semibold text-lg leading-snug mb-2 group-hover:text-[#00E5FF] transition-colors line-clamp-2">{course.title}</h3>
        <p className="font-body text-sm text-[#8A8D98] line-clamp-2 mb-4">{course.short_description}</p>
        <div className="flex items-center gap-4 mb-4 font-mono text-xs text-[#525560]">
          <span className="flex items-center gap-1"><Star className="w-3.5 h-3.5 fill-[#FFB020] text-[#FFB020]" /> {course.rating}</span>
          <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {course.duration_hours}h</span>
          <span className="flex items-center gap-1"><BarChart3 className="w-3.5 h-3.5" /> {course.level}</span>
        </div>
        <div className="flex items-center justify-between pt-4 border-t border-white/5">
          <span className="font-mono font-bold text-lg text-[#00E5FF]">{formatPrice(course.price, course.currency)}</span>
          <span className="font-body text-xs text-[#525560]">{course.students_count?.toLocaleString()} alumnos</span>
        </div>
      </div>
    </div>
  );
}
